// 공통 유틸리티 함수들 (캐릭터별 로직은 각 config에 이동됨)

export const transposeArray = (array: number[][]): number[][] => {
  const rowCount = array.length;
  const colCount = array[0].length;

  const transposed: number[][] = Array.from({ length: colCount }, () => Array(rowCount).fill(0));

  for (let i = 0; i < rowCount; i++) {
    for (let j = 0; j < colCount; j++) {
      transposed[j][i] = array[i][j];
    }
  }
  return transposed;
}

/**
 * BlendShape 데이터를 최대 개수로 정규화 (초과 시 자르기)
 * @param blendshape 원본 블렌드셰이프 데이터 [프레임][인덱스]
 * @param maxCount 최대 인덱스 개수 (기본값: 52)
 */
export const normalizeBlendshapeData = (
  blendshape: number[][],
  maxCount: number = 52
): number[][] => {
  return blendshape.map(frame => {
    if (frame.length > maxCount) {
      return frame.slice(0, maxCount);
    }
    return frame;
  });
};

/**
 * Transposed BlendShape 배열을 모델의 morphTarget 개수에 맞게 조정
 * @param transposedBlendShapes 전치된 블렌드셰이프 데이터 [인덱스][프레임]
 * @param morphTargetCount 모델의 morphTargetInfluences 개수
 * @param frameCount 프레임 수
 */
export const adjustBlendshapesToModel = (
  transposedBlendShapes: number[][],
  morphTargetCount: number,
  frameCount: number
): number[][] => {
  const result: number[][] = [];

  for (let i = 0; i < morphTargetCount; i++) {
    if (i < transposedBlendShapes.length && transposedBlendShapes[i]?.length > 0) {
      result.push(transposedBlendShapes[i]);
    } else {
      // 데이터가 없는 인덱스는 0으로 채운 배열
      result.push(Array(frameCount).fill(0));
    }
  }

  return result;
};